import Icon, { iconColor, iconTypes } from "../../common/components/Icon";

import Modal from "../../common/components/Modal";
import PropTypes from "prop-types";
import React from "react";

let cameraCount = 0;

export default class BarCodeScanner extends React.PureComponent {
    constructor(props) {
        super(props);

        this.videoElementRef = React.createRef();
        this.selectedDeviceIdx = null;
        this.reader = null;
        this.startCameraScanner = this.startCameraScanner.bind(this);
        this.switchCamera = this.switchCamera.bind(this);

        this.asyncModule = null;

        this.tickCount = 0;

        const screenWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        const screenHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

        this.state = {
            videoHeight: Math.round(screenHeight * 0.9),
            videoWidth: Math.round(screenWidth * 0.9),
            opacityOnScanIndicator: 0.9,
            starting: true
        };

        this.updateVideoDimensions = this.updateVideoDimensions.bind(this);
        this.updateVideoDimensionsInterval = setInterval(this.updateVideoDimensions, 500);
    }

    componentDidMount() {
        this.startCameraScanner();
    }

    componentWillUnmount() {
        clearInterval(this.updateVideoDimensionsInterval);
        try {
            if (this.reader) {
                this.reader.reset();
            }
        } catch(_) {
            //
        }
    }

    async startCameraScanner() {
        const {
            BrowserMultiFormatReader,
            BarcodeFormat,
            DecodeHintType
        } = this.asyncModule != null ? this.asyncModule : (await import(/*webpackChunkName: "camera" */ "@zxing/library"));

        this.setState({
            starting: true
        });

        cameraCount++;
        const count = cameraCount;

        if (!this.asyncModule) {
            this.asyncModule = {
                BrowserMultiFormatReader,
                BarcodeFormat,
                DecodeHintType
            };
        }

        if (this.reader) {
            this.reader.reset();
        }

        const hints = new Map();
        hints.set(DecodeHintType.POSSIBLE_FORMATS, [BarcodeFormat.CODE_128, BarcodeFormat.EAN_13, BarcodeFormat.EAN_8]);
        // Possible an improvement with the below line, but it makes the capture incredibly sluggish on old devices
        //hints.set(DecodeHintType.TRY_HARDER, true);

        this.reader = new BrowserMultiFormatReader(hints);
        const cameraDevices = await this.reader.listVideoInputDevices();

        if (cameraDevices.length === 0) {
            this.props.onCancel();
            return;
        }

        if (this.selectedDeviceIdx == null) {
            try {
                const localStorageDeviceId = localStorage.getItem("kundeWebCameraScannerDeviceId");
                const localStorageDevice = cameraDevices.find(d => d.deviceId === localStorageDeviceId);
                if (localStorageDevice) {
                    this.selectedDeviceIdx = cameraDevices.indexOf(localStorageDevice);
                } else {
                    this.selectedDeviceIdx = null;
                }
            } catch(_) {
                this.selectedDeviceIdx = null;
            }
        }

        if (this.selectedDeviceIdx != null && this.selectedDeviceIdx >= cameraDevices.length || this.selectedDeviceIdx < 0) {
            this.selectedDeviceIdx = 0;
        }


        const device = this.selectedDeviceIdx != null ? cameraDevices[this.selectedDeviceIdx] : null;

        try {
            if (device) {
                localStorage.setItem("kundeWebCameraScannerDeviceId", device.deviceId);
            }
        } catch (_) {
            //
        }

        try {
            this.setState({
                starting: false
            });
            const result = await this.reader.decodeOnceFromVideoDevice(device ? device.deviceId : undefined, this.videoElementRef.current);
            if (result && result.text) {
                this.props.onBarcodeFound(result.text);
            }
        } catch(_) {
            if (count === cameraCount) {
                this.props.onCancel();
            }
        }
    }

    async switchCamera() {
        try {
            this.setState({
                starting: true
            });

            if (this.reader && this.reader.stream && this.reader.stream.active) {
                const tracks = this.reader.stream.getVideoTracks();
                if (tracks && tracks.length > 0) {
                    const settings = tracks[0].getSettings();
                    if (settings && settings.deviceId && settings.deviceId) {
                        const cameraDevices = await this.reader.listVideoInputDevices();
                        const device = cameraDevices.find(d => d.deviceId === settings.deviceId);
                        if (device && device.deviceId) {
                            this.selectedDeviceIdx = cameraDevices.indexOf(device);
                        }
                    }
                }
            }
        } catch (_) {
            //
        }

        this.selectedDeviceIdx = (this.selectedDeviceIdx || 0) + 1;
        this.startCameraScanner();
    }

    updateVideoDimensions() {
        try {
            if (this.videoElementRef.current) {
                if (this.videoElementRef.current.videoWidth != null && this.videoElementRef.current.videoHeight != null) {
                    if ((this.state.videoWidth != this.videoElementRef.current.videoWidth || this.state.videoHeight != this.videoElementRef.current.videHeight)
                        && (this.videoElementRef.current.videoWidth > 0 && this.videoElementRef.current.videoHeight > 0)) {
                        this.setState({
                            videoHeight: this.videoElementRef.current.videoHeight,
                            videoWidth: this.videoElementRef.current.videoWidth
                        });
                    }
                }
            }
        } catch(_) {
            //
        }

        this.tickCount++;

        const opacity = Math.round(this.tickCount / 2) % 2 === 0 ? 0.9 : 0.1;
        if (this.state.opacityOnScanIndicator !== opacity) {
            this.setState({
                opacityOnScanIndicator: opacity
            });
        }
    }

    render() {
        let width = this.state.videoWidth;
        let height = this.state.videoHeight;

        const screenWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        const screenHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

        if (width > height) {
            height = Math.round((this.state.videoHeight / this.state.videoWidth) * screenWidth * 0.9);
            width = Math.round(screenWidth * 0.9);

            if (height > screenHeight) {
                width = Math.round((this.state.videoWidth / this.state.videoHeight) * screenHeight * 0.9);
                height = Math.round(screenHeight * 0.9);
            }
        } else {
            width = Math.round((this.state.videoWidth / this.state.videoHeight) * screenHeight * 0.9);
            height = Math.round(screenHeight * 0.9);

            if (width > screenWidth) {
                height = Math.round((this.state.videoHeight / this.state.videoWidth) * screenWidth * 0.9);
                width = Math.round(screenWidth * 0.9);
            }
        }

        return (
            <Modal innerWidth={width} innerHeight={height} onCloseModal={this.props.onCancel} hideCard={true} drawAboveMenu={true}>
                {!this.state.starting && (
                    <button key="_switchButton" style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        zIndex: "10000"
                    }} className="btn circular noselect" onClick={this.switchCamera}>
                        <Icon type={iconTypes.change} color={iconColor.white}/>
                    </button>
                )}
                <video
                    key="_videoElement"
                    className="noselect"
                    width={width}
                    height={height}
                    ref={this.videoElementRef}
                    style={{
                        borderRadius: "8px",
                        background: "#f6f7f8"
                    }}
                ></video>
                <div key="_topLeft" style={{
                    width: "20%",
                    height: "20%",
                    position: "absolute",
                    left: "20px",
                    top: "20px",
                    borderTop: "2px solid #3dc184",
                    borderLeft: "2px solid #3dc184",
                    opacity: this.state.opacityOnScanIndicator
                }}></div>
                <div key="_topRight" style={{
                    width: "20%",
                    height: "20%",
                    position: "absolute",
                    right: "20px",
                    top: "20px",
                    borderTop: "2px solid #3dc184",
                    borderRight: "2px solid #3dc184",
                    opacity: this.state.opacityOnScanIndicator
                }}></div>
                <div key="_bottomLeft" style={{
                    width: "20%",
                    height: "20%",
                    position: "absolute",
                    left: "20px",
                    bottom: "20px",
                    borderBottom: "2px solid #3dc184",
                    borderLeft: "2px solid #3dc184",
                    opacity: this.state.opacityOnScanIndicator
                }}></div>
                <div key="_bottomRight" style={{
                    width: "20%",
                    height: "20%",
                    position: "absolute",
                    right: "20px",
                    bottom: "20px",
                    borderBottom: "2px solid #3dc184",
                    borderRight: "2px solid #3dc184",
                    opacity: this.state.opacityOnScanIndicator
                }}></div>
            </Modal>
        );
    }
}

BarCodeScanner.propTypes = {
    onBarcodeFound: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
};